module.exports = __webpack_public_path__ + "img/messenger.17f01a2.png";